<template>
  <v-list dense>
    <v-list-item-group color="primary">
      <v-list-item
        v-for="(item, key) in optionSet"
        :key="key"
        @click="setUnit(key)"
      >
        <v-list-item-icon>
          <v-icon
            :color="decodeKey(key).color"
            v-text="decodeKey(key).icon1"
          ></v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="decodeKey(key).name"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
export default {
  props: {
    optionSet: Object,
    setUnit: Function,
  },
  data: () => ({
    selected: 0,
  }),
  methods: {
    decodeKey(key) {
      /*
      This function decodes a key, formatted like
      [unit type][version of unit type]_[number of unit]
      it will return a legible string for the 
      selection list in the template
      */
      const unitKey = {
        T: "TOWNHOME",
        F: "FLAT",
        C: "CLUBHOUSE",
      };
      const iconKey = {
        // Material icon to place next to unit in list
        A: "alpha-a-box",
        B: "alpha-b-box",
        T: "home-floor-t",
        F: "home-floor-f",
        C: "pool",
      };
      const colorKey = {
        // give unit type and version a color
        TA: "teal lighten-2",
        TB: "blue",
        FA: "#ff46e3",
        FB: "orange",
        CA: "green lighten-2",
      };
      if (key[0] == "C") {
        return {
          name: "Clubhouse",
          icon1: "mdi-" + iconKey["C"],
          color: colorKey["CA"],
        };
      } else {
        return {
          name: unitKey[key[0]] + " " + key[1] + " #" + key[3],
          icon1: "mdi-" + iconKey[key[1]],
          color: colorKey[key[0] + key[1]],
        };
      }
    },
  },
};
</script>
